<nav
  class="navbar navbar-icon-top navbar-expand-lg pl-0"
  [ngClass]="{ 'open-menu': menuOpen }">
  <div class="box-logo">
    <img
      src="assets/img/logo-negative.png"
      class="logo"
      [hidden]="theme === 'positive'"/>
    <img
      src="assets/img/logo-positive.png"
      class="logo"
      [hidden]="theme === 'negative'"/>
  </div>
  <button (click)="clickOpenMenu($event)" class="btn ml-1 btn-menu">
    <i class="fas fa-bars"></i>
  </button>
  <h1 class="title mr-3 ml-3 pt-1">
    <span class="semi-bold">{{ globalTitle }}</span>
  </h1>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
    <ul class="navbar-nav ml-md-auto btn-group" dropdown>
      <li class="nav-item" *ngIf="infoSistemaDisponivel()">
        <p class="navbar-text">{{ infoSistema.version }}</p>
      </li>
      <li class="nav-item" dropdown>
      </li>
      <li class="nav-item user" dropdown>
        <button
          class="user-btn ml-3 text-uppercase"
          type="button"
          dropdownToggle
          href="#"
          placement="right"
          aria-controls="drop-change">
          {{ username | slice: 0:2 }}
        </button>
        <div
          class="dropdown-menu"
          id="drop-change"
          *dropdownMenu
          class="dropdown-menu dropdown-menu-right"
          role="menu"
          aria-labelledby="drop-change">
          <ul class="box-user p-1">
            <li>
              <p class="text-thin">
                Olá, <span class="text-bold"> {{ username }}</span>!
              </p>
            </li>
            <!-- <li>
              <maps-color [name]="theme" (themeColor)="selectTheme($event)">
              </maps-color>
            </li> -->
            <li>
              <maps-button
                [textButton]="'Sair'"
                (click)="outSystem()"
                [type]="'out'"
                [icon]="'fas fa-sign-out-alt'"
                [size]="'lg'">
              </maps-button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</nav>
